import { ApolloLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { AuthenticationService } from "../services/authentication.service";
import { isEmptyValue } from "../utils/is-empty-value";
import {
	agreementsLink,
	casesLink,
	dataLink,
	dataSubscriptionsLink,
	financialsLink,
	modelsLink,
	moduleLibrarySubscriptions,
} from "./apollo-module-endpoints";

const splitLinkWithSubscriptions = (mainLink: ApolloLink, subscriptionLink: ApolloLink) =>
	ApolloLink.split(
		({ query }) => {
			const definition = getMainDefinition(query);
			return definition.kind === "OperationDefinition" && definition.operation === "subscription";
		},
		subscriptionLink,
		mainLink
	);

export const link = (authenticationService: AuthenticationService) => {
	const module5Link = ApolloLink.split(
		(operation) => isEmptyValue(operation.getContext().module) || operation.getContext().module === "data",
		splitLinkWithSubscriptions(dataLink, dataSubscriptionsLink(authenticationService))
	);
	const module4Link = ApolloLink.split((operation) => operation.getContext().module === "financials", financialsLink, module5Link);
	const module3Link = ApolloLink.split((operation) => operation.getContext().module === "cases", casesLink, module4Link);
	const module2Link = ApolloLink.split((operation) => operation.getContext().module === "agreements", agreementsLink, module3Link);
	const modules1And2Link = ApolloLink.split(
		(operation) => operation.getContext().module === "models",
		splitLinkWithSubscriptions(modelsLink, moduleLibrarySubscriptions(authenticationService)),
		module2Link
	);

	return modules1And2Link;
};

export const apolloLinkDefaultTimeout = 10000;
